export const APP_NAME = 'Imsenta';
export const APP_TAGLINE = 'Your management system, governed';
export const API_VERSION = 'v1';
